import { Injectable } from '@angular/core';

@Injectable()
export class ApiAuthStorageService {
  private _user: any;

  get user(): any {
    return this._user;
  }

  set user(user: any) {
    this._user = user;
  }

  get type(): any {
    return this._user;
  }

  get userId(): number {
    return this.user?.id;
  }

  hasPermissions(permissions: string | string[]) {
    if (typeof permissions == 'string') {
      permissions = [permissions];
    }

    return !permissions.find(
      (permission) => !this._user?.accesses.includes(permission)
    );
  }
}
